import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";
import { FlywireProperties, useFlywireProperties } from "./FlywireProperties";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";
import { FlywireButton } from "./FlywireButton";
import { DraftFlyrwireButtonComponent } from "./DraftFlyrwireButtonComponent";

export const FlywireButtonComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = useFlywireProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) return <></>

    return (
        <FlywireButton {...properties}
            className={className}>
            {children}
        </FlywireButton>
    )
}

Registry.addControl({
    id: "c14cc6af-266c-4d8c-b268-a76c0dd908cd",
    name: "Flywire Button",
    type: ControlType.FlywireButton,
    properties: FlywireProperties,
    component: FlywireButtonComponent,
    draftComponent: DraftFlyrwireButtonComponent
})
